export default class FAQService {
  constructor() {
    this.networkDelay = 2000;
  }

  fetchFAQItems() {
    return new Promise((resolve, reject) => {
      try {
        let faq = [];
        let topics = ["topic 1", "topic 2", "topic 3", "topic 4"];
        setTimeout(() => {
          topics.forEach(topic => {
            faq.push({
              topic: topic,
              items: this.generateFAQItems(topic, 5)
            });
          });

          resolve(faq);
        }, this.networkDelay);
      } catch (error) {
        reject(error);
      }
    });
  }

  generateFAQItems(topic, count) {
    let faqItems = [];
    for (let i = 0; i < count; ++i) {
      faqItems.push({
        id: i,
        question: `${topic} - question ${i}`,
        answer: `${topic} - question ${i} - answer ${i}`
      });
    }
    return faqItems;
  }
}
